/**
 * ─────────────────────────────────────────────────────────────────
 * ADS SECTION SCROLL ANIMATIONS & SLIDER
 * ─────────────────────────────────────────────────────────────────
 * Handles GSAP animations and the auto-rotating slider for the 
 * Digital Marketing section (Google Ads / SEO slides).
 */

function initAdsSection() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn('GSAP or ScrollTrigger not loaded. Ads animations aborted.');
        return;
    }

    const adsSection = document.querySelector('.sem-section');
    if (!adsSection) return;

    const slides = adsSection.querySelectorAll('.js-ads-slide');
    const dots = adsSection.querySelectorAll('.ads-nav-dot');
    if (!slides.length) return;

    let currentSlide = 0;
    let slideTimer = null;
    let isPaused = false;
    let hasStarted = false;

    // 1. Function to play GSAP animation for a specific slide
    function playSlideAnimation(slideIndex) {
        const slide = slides[slideIndex];
        
        // Reset and prepare SVG elements
        const chartLine = slide.querySelector('.ads-chart-line');
        const chartArea = slide.querySelector('.ads-chart-area');
        const chartDots = slide.querySelectorAll('circle');
        
        if (chartLine) {
            const pathLength = chartLine.getTotalLength();
            gsap.set(chartLine, { strokeDasharray: pathLength, strokeDashoffset: pathLength });
        }
        if (chartArea) gsap.set(chartArea, { opacity: 0, y: 10 });
        if (chartDots.length) gsap.set(chartDots, { scale: 0, transformOrigin: "center center" });

        // Setup Number Counters back to 0
        const counters = slide.querySelectorAll('.js-ads-counter');
        counters.forEach(counter => {
            const prefix = counter.getAttribute('data-prefix') || '';
            const suffix = counter.getAttribute('data-suffix') || '';
            counter.innerHTML = `${prefix}0${suffix}`;
        });

        const tl = gsap.timeline();

        if (chartLine) {
            tl.to(chartLine, { strokeDashoffset: 0, duration: 1.5, ease: "power2.inOut" }, 0.2);
        }
        if (chartArea) {
            tl.to(chartArea, { opacity: 1, y: 0, duration: 1.2, ease: "power2.out" }, 0.5); 
        }
        if (chartDots.length) {
            tl.to(chartDots, { scale: 1, duration: 0.4, stagger: 0.15, ease: "back.out(1.7)" }, 0.8);
        }

        // Animate counters
        tl.add(() => {
            counters.forEach(counter => {
                const targetVal = parseFloat(counter.getAttribute('data-target') || 0);
                const prefix = counter.getAttribute('data-prefix') || '';
                const suffix = counter.getAttribute('data-suffix') || '';
                const isFloat = targetVal % 1 !== 0; 
                
                const countObj = { val: 0 };
                gsap.to(countObj, {
                    val: targetVal,
                    duration: 1.5,
                    ease: "power2.out",
                    onUpdate: function() {
                        const displayVal = isFloat ? countObj.val.toFixed(1) : Math.floor(countObj.val);
                        counter.innerHTML = `${prefix}${displayVal}${suffix}`;
                    }
                });
            });
        }, 0.2);
    }

    // 2. Function to switch slides
    function goToSlide(index) {
        // Update classes
        slides[currentSlide].classList.remove('active');
        if(dots[currentSlide]) dots[currentSlide].classList.remove('active');
        
        currentSlide = index;
        
        slides[currentSlide].classList.add('active');
        if(dots[currentSlide]) dots[currentSlide].classList.add('active');

        // Play animation for new slide
        playSlideAnimation(currentSlide);
    }

    function nextSlide() {
        if (isPaused) return;
        let nextIndex = (currentSlide + 1) % slides.length;
        goToSlide(nextIndex);
    }

    // 3. Setup ScrollTrigger to kick off the slider
    ScrollTrigger.create({
        trigger: adsSection,
        start: "top 60%", 
        once: true,
        onEnter: () => {
            if (hasStarted) return;
            hasStarted = true;
            
            // Initial animation for first slide
            playSlideAnimation(currentSlide);
            
            // Start the 4-second auto-rotation timer
            slideTimer = setInterval(nextSlide, 4000);
        }
    });

    // 4. Hover to pause events
    const sliderContainer = adsSection.querySelector('.js-slider-container');
    if (sliderContainer) {
        sliderContainer.addEventListener('mouseenter', () => { isPaused = true; });
        sliderContainer.addEventListener('mouseleave', () => { isPaused = false; });
    }

    // 5. Dot click events (optional but good for UX)
    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            if (index === currentSlide) return;
            
            // Reset timer so it doesn't swap immediately after a manual click
            clearInterval(slideTimer);
            goToSlide(index);
            slideTimer = setInterval(nextSlide, 4000);
        });
    });
}
